var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStreamlineIconBusinessDeal250X250(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 250 250",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.625,0,0,0.625,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2,0,0,2,0,0)"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#f2f5c8;}.b{fill:#219f94;}.c{fill:#000000;}.d,.e{fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:0.687px;}.d{stroke:#f2f5c8;}.e{stroke:#000000;}")), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M87.092,122.6a3.391,3.391,0,0,1,.01-1.529c.932-4.125.791-10.212,1.722-15.161s4-4.392,7.393-5.578c2.166-.76,4.193-1.928,6.5-3a29.882,29.882,0,0,1,4.255-1.646c4.32-1.272,15.164,3.3,20.416,4.141a23.284,23.284,0,0,1,3.657.89l.024-.072s23.952-16.418,30.214-20.914S180.4,66.106,180.4,66.106l14.641,33.72s-28.746,19-33,22.746-13.61,8.507-13.61,8.507l-.076-.018c-.571,2.616-2.471,5.6-7.709,8.558l-.316.11a27.987,27.987,0,0,0-3.266-5.622c-5.224-9.61-26.53-23.85-28.372-23.544s-6.929.976-6.929.976c-.374,1.124-1.938,1.753-1.938,1.753l-.134,0a14.527,14.527,0,0,1-3.3,9.328C92.983,126.92,87.793,125.7,87.092,122.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M146.353,38.012a17.7,17.7,0,0,1,.385,4.671,1.957,1.957,0,0,1-2.279,1.814l-7.118-1.175a1.944,1.944,0,0,1-1.633-1.8,5.2,5.2,0,0,0-1.2-3.2,6.533,6.533,0,0,0-1.024-.959l-2.048,12.411,2.925,1.77q6.036,3.558,7.757,8.256A18.994,18.994,0,0,1,143,69.587a17.5,17.5,0,0,1-2.413,6.517,18.075,18.075,0,0,1-4.468,4.9,16.479,16.479,0,0,1-6.045,2.835,16.74,16.74,0,0,1-4.341.478l-.98,5.943a2.541,2.541,0,1,1-5.014-.829l.969-5.87a16.4,16.4,0,0,1-8.792-5.857,15.614,15.614,0,0,1-2.488-4.509c-.176-.485-.334-.983-.471-1.5a16.968,16.968,0,0,1-.571-4.121,3.08,3.08,0,0,1,3.575-3.11l3.007.5v0l2.134.351a3.082,3.082,0,0,1,2.527,2.53,11.05,11.05,0,0,0,.756,2.543,4.219,4.219,0,0,0,2.141,2.162l2.31-14L122.283,57.1a19.126,19.126,0,0,1-7.54-7.461,15.691,15.691,0,0,1-1.495-10.3,16.874,16.874,0,0,1,2.467-6.506,16.637,16.637,0,0,1,4.62-4.757,15.484,15.484,0,0,1,5.887-2.574,17.515,17.515,0,0,1,4.125-.361l.862-5.227a2.541,2.541,0,0,1,5.015.828l-.859,5.214a16.327,16.327,0,0,1,3.911,1.76,15.05,15.05,0,0,1,4.568,4.358A16.957,16.957,0,0,1,146.353,38.012ZM132.1,68.02a6.783,6.783,0,0,0-.574-4.275,7.321,7.321,0,0,0-2.018-2.324l-1.917,11.61a7.486,7.486,0,0,0,1.773-.756A5.691,5.691,0,0,0,132.1,68.02ZM126.755,46.9l1.77-10.72a4.692,4.692,0,0,0-2.265,1.069,6.137,6.137,0,0,0-2.134,3.774,6.743,6.743,0,0,0,.278,3.241A5.8,5.8,0,0,0,126.755,46.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M87.092,122.6c.7,3.1,5.891,4.317,9.294.021a14.527,14.527,0,0,0,3.3-9.328l.134,0s1.564-.629,1.938-1.753c0,0,5.083-.67,6.929-.976s23.148,13.934,28.372,23.544a27.987,27.987,0,0,1,3.266,5.622c.567,1.465.783,2.86.1,3.668-2.355,2.8-5.235,1.976-7.256-.351-.1-.113-.2-.234-.3-.357-2.032-2.595-7.246-8.93-7.246-8.93l-4.351-2.7a32.572,32.572,0,0,1,2.853,3.035c1.165,1.588,5.747,6.266,7.805,9.473a5.242,5.242,0,0,1,1.011,2.371,3.979,3.979,0,0,1-5.5,3.4,1.2,1.2,0,0,1-.207-.11c-1.742-1.079-10.317-8.771-11.648-10.025a4.017,4.017,0,0,0-1.075-1.272,6.215,6.215,0,0,0-.853-.577l-.013-.011c-2.255-1.282-4.723-.8-6.854.866-2.351,1.846-1.32.756-2.337,1.815a3.857,3.857,0,0,0-1.014-2.227c-2.107-2.365-4.963-2.482-7.651-1.035a60.1,60.1,0,0,0-5.994,3.939h0l-7.823.749-.068-.013a6.017,6.017,0,0,0-.853-4c-1.7-2.564-4.251-2.3-5.595-2.22a2.951,2.951,0,0,0-.65.117l-.017-.117a28.163,28.163,0,0,1-3.021-1.726c-1.272-.794-2.653-1.708-3.757-2.45-1.216-.818-2.089-1.423-2.089-1.423a230.564,230.564,0,0,1,2.161-29.641l1.764.684c2.859,1.11,8.262,3.2,8.953,3.444a2.3,2.3,0,0,0,2.145,0c.979-.371,12.493-6.434,14.82-6.987s6.946.209,6.946.209v0c-2.31,1.076-4.337,2.244-6.5,3-3.389,1.186-6.465.625-7.393,5.578s-.79,11.036-1.722,15.161A3.391,3.391,0,0,0,87.092,122.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M132.88,142.689c.1.123.2.244.3.357,0,0-1.21.56-1.234.523-2.058-3.207-6.64-7.885-7.805-9.473a32.572,32.572,0,0,0-2.853-3.035l4.351,2.7S130.848,140.094,132.88,142.689Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M127.246,149.229l-.237.347a3.051,3.051,0,0,1-1.663,2.173,5.178,5.178,0,0,1-4.118.611,14.842,14.842,0,0,1-1.79-1.027l-.915-.1a7.8,7.8,0,0,0,1.217-1.434c1.3-2.192,1.255-3.55-.179-4.691a4.237,4.237,0,0,0-4.11-.986l-.152-.093a2.81,2.81,0,0,0,.2-.4,5.171,5.171,0,0,0,.1-4.42C116.929,140.458,125.5,148.15,127.246,149.229Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M121.228,152.36a9.161,9.161,0,0,1-4.753,3.094,2.886,2.886,0,0,1-2.416-.213l-.468-.007a49.287,49.287,0,0,0,4.932-4l.915.1A14.842,14.842,0,0,0,121.228,152.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M119.561,145.1c1.434,1.141,1.475,2.5.179,4.691a7.8,7.8,0,0,1-1.217,1.434,49.287,49.287,0,0,1-4.932,4c-.574.416-.941.67-.941.67-5.658,3.324-8.167,4.062-10.191,3.11a4.474,4.474,0,0,1-2.629-2.88l-.1-.227a54.319,54.319,0,0,0,6.586-3.44s7.4-5.757,8.98-8.441l.152.093A4.237,4.237,0,0,1,119.561,145.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M115.6,139.2a5.171,5.171,0,0,1-.1,4.42,2.81,2.81,0,0,1-.2.4c-1.581,2.684-8.98,8.441-8.98,8.441a54.319,54.319,0,0,1-6.586,3.44c-4.7,1.956-5.794.8-7.482.007a6.9,6.9,0,0,1-3.361-4.035l0-.048a10.883,10.883,0,0,0,4.018-1.1s9.17-4.9,10.548-7.159a5.763,5.763,0,0,0,1.014-3.547c1.017-1.059-.014.031,2.337-1.815,2.131-1.667,4.6-2.148,6.854-.866l.013.011a6.215,6.215,0,0,1,.853.577A4.017,4.017,0,0,1,115.6,139.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M89.8,140.7h0a60.49,60.49,0,0,1,6-3.939c2.688-1.447,5.544-1.33,7.651,1.035a3.859,3.859,0,0,1,1.014,2.227,5.763,5.763,0,0,1-1.014,3.547c-1.378,2.258-10.548,7.159-10.548,7.159a10.883,10.883,0,0,1-4.018,1.1,23.042,23.042,0,0,1-7.84-1.1c-2.759-.715-4.076-5.877-4.076-5.877a12.054,12.054,0,0,0,3.059-.928,3.246,3.246,0,0,0,1.884-2.488l.068.013Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "101.442 15.238 102.091 18.38 63.415 26.35 73.901 77.242 70.756 77.888 70.107 74.743 59.624 23.855 98.297 15.885 101.442 15.238"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "98.297 15.885 59.624 23.855 70.107 74.743 66.962 75.393 55.829 21.356 97.651 12.74 98.297 15.885"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M74.815,135.334a2.951,2.951,0,0,1,.65-.117c1.344-.076,3.89-.344,5.595,2.22a6.017,6.017,0,0,1,.853,4,3.246,3.246,0,0,1-1.884,2.488,12.054,12.054,0,0,1-3.059.928c-2.347.395-4.788.182-5.86-.873-1.8-1.777-3.736-5.86.468-10.173l.2-.317a28.163,28.163,0,0,0,3.021,1.726Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M69.254,98.252l-.038.031a.421.421,0,0,0-.649-.031,4.843,4.843,0,0,0-.475,1.725,230.564,230.564,0,0,0-2.161,29.641c.044,2.285.226,3.791.594,3.994a1.058,1.058,0,0,0,.787.171l.014.045c-1.024.681-3.757,1.024-4.5-1.137a27.348,27.348,0,0,1-.041-5.273c.354-8.5,1.739-24.5,2.5-28.884a4.031,4.031,0,0,1,.282-1.11C66.388,96.348,69.158,96.967,69.254,98.252Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M65.1,98.5l.189.035c-.763,4.389-2.148,20.388-2.5,28.884l-.1,0s-5.925-2.66-8.936-3.018c-4.365-.515-48.712-21.11-48.712-21.11L22.009,70.241,62.342,97.128Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    x1: 180.396,
    y1: 66.106,
    x2: 195.037,
    y2: 99.826
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    x1: 5.037,
    y1: 103.287,
    x2: 22.009,
    y2: 70.241
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M145.431,174.543A72.7,72.7,0,0,1,32.839,118.874"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M178,116.083a72.531,72.531,0,0,1-26.523,53.992"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M137.32,162.964A57.971,57.971,0,0,1,48.563,126.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M162.314,125.4a57.926,57.926,0,0,1-20.172,34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M144.328,71.928a58.157,58.157,0,0,1,9.084,10.407"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M53.592,88.845a58.18,58.18,0,0,1,10.342-14.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M140.905,50.492A73.088,73.088,0,0,1,164.16,71.179"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M41.116,79.868A73,73,0,0,1,59.871,57.207"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M131.072,100.644s23.952-16.418,30.214-20.914S180.4,66.106,180.4,66.106"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M148.429,131.079s9.355-4.764,13.61-8.507,33-22.746,33-22.746"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M5.037,103.287s44.348,20.6,48.713,21.11c3.011.358,8.936,3.018,8.936,3.018"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "e",
    points: "65.102 98.499 62.342 97.128 22.009 70.241"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M69.89,100.572a5.64,5.64,0,0,0-.674-2.289.421.421,0,0,0-.649-.031,4.843,4.843,0,0,0-.475,1.725,230.564,230.564,0,0,0-2.161,29.641c.044,2.285.226,3.791.594,3.994a1.058,1.058,0,0,0,.787.171c.9-.233.609-2.45.609-2.45"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M69.254,98.252c-.1-1.285-2.866-1.9-3.681-.828a4.031,4.031,0,0,0-.282,1.11c-.763,4.389-2.148,20.388-2.5,28.884a27.348,27.348,0,0,0,.041,5.273c.739,2.161,3.472,1.818,4.5,1.137"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M68.092,99.977l1.764.684c2.859,1.11,8.262,3.2,8.953,3.444a2.3,2.3,0,0,0,2.145,0c.979-.371,12.493-6.434,14.82-6.987s6.946.209,6.946.209"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M65.931,129.618s.873.605,2.089,1.423c1.1.742,2.485,1.656,3.757,2.45a28.163,28.163,0,0,0,3.021,1.726"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M148.085,124.524c0,1.451.869,3.788.268,6.537-.571,2.616-2.471,5.6-7.709,8.559"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M135.777,102.971a18.338,18.338,0,0,0-4.729-2.255,23.284,23.284,0,0,0-3.657-.89c-5.252-.839-16.1-5.413-20.416-4.141a29.882,29.882,0,0,0-4.255,1.646c-2.31,1.076-4.337,2.244-6.5,3-3.389,1.186-6.465.625-7.393,5.578s-.79,11.036-1.722,15.161a3.391,3.391,0,0,0-.01,1.529c.7,3.1,5.891,4.317,9.294.021a14.527,14.527,0,0,0,3.3-9.328,13.6,13.6,0,0,0-.323-2.85"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M99.823,113.292s1.564-.629,1.938-1.753c0,0,5.083-.67,6.929-.976s23.148,13.934,28.372,23.544"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M137.062,134.107a27.987,27.987,0,0,1,3.266,5.622c.567,1.465.783,2.86.1,3.668-2.355,2.8-5.235,1.976-7.256-.351-.1-.113-.2-.234-.3-.357-2.032-2.595-7.246-8.93-7.246-8.93l-4.351-2.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M113.67,121.837a8.994,8.994,0,0,0,.688,2.687c.285.33,4.086,3.757,6.925,6.537a32.572,32.572,0,0,1,2.853,3.035c1.165,1.588,5.747,6.266,7.805,9.473a5.242,5.242,0,0,1,1.011,2.371,3.979,3.979,0,0,1-5.5,3.4,1.2,1.2,0,0,1-.207-.11c-1.742-1.079-10.317-8.771-11.648-10.025l-.006-.007"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M127.009,149.576a3.051,3.051,0,0,1-1.663,2.173,5.178,5.178,0,0,1-4.118.611,14.842,14.842,0,0,1-1.79-1.027"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M121.228,152.36a9.161,9.161,0,0,1-4.753,3.094,2.886,2.886,0,0,1-2.416-.213"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M108.69,110.563s1.554-1.54,1.554-2.416"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M101.761,111.539a5.837,5.837,0,0,0,0-2.186"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M87.013,122.28a.686.686,0,0,0,.079.323c.622,1.258,4.984.852,6.383-1.244,1.508-2.265-.334-5.276-.334-5.276"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M87.941,115.265s1.12-.086,2.6-.258"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M136.564,143.569a6.935,6.935,0,0,0,2.746-1.561"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M133.175,143.046s-1.21.56-1.234.523"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M72.43,136.6a8.413,8.413,0,0,1,2.385-1.261,2.951,2.951,0,0,1,.65-.117c1.344-.076,3.89-.344,5.595,2.22a6.017,6.017,0,0,1,.853,4,3.246,3.246,0,0,1-1.884,2.488,12.054,12.054,0,0,1-3.059.928c-2.347.395-4.788.182-5.86-.873-1.8-1.777-3.736-5.86.468-10.173"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M89.8,140.7c-.794.578-1.454,1.069-1.863,1.372"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M76.97,144.854s1.317,5.162,4.076,5.877a23.042,23.042,0,0,0,7.84,1.1,10.883,10.883,0,0,0,4.018-1.1s9.17-4.9,10.548-7.159a5.763,5.763,0,0,0,1.014-3.547,3.859,3.859,0,0,0-1.014-2.227c-2.107-2.365-4.963-2.482-7.651-1.035a60.1,60.1,0,0,0-5.994,3.939"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "e",
    points: "89.807 140.702 89.804 140.702 81.981 141.451"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M95.987,140.29a4.228,4.228,0,0,0-1,2.756,2.608,2.608,0,0,0,3.839,1.994c1.777-.983,4.623-2.973,3.84-4.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M97.207,139.2a4.642,4.642,0,0,1,2.193-1.083,2.274,2.274,0,0,1,1.571.54"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M113.657,137.344c-2.255-1.282-4.723-.8-6.854.866-2.351,1.846-1.32.756-2.337,1.815-.021.021-.041.045-.065.069"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M88.89,151.879a6.9,6.9,0,0,0,3.361,4.035c1.688.794,2.787,1.949,7.482-.007a54.319,54.319,0,0,0,6.586-3.44s7.4-5.757,8.98-8.441a2.81,2.81,0,0,0,.2-.4,5.171,5.171,0,0,0,.1-4.42,4.017,4.017,0,0,0-1.075-1.272,6.215,6.215,0,0,0-.853-.577"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M107.583,141.654a4.243,4.243,0,0,0-.512,2.887,2.609,2.609,0,0,0,4.121,1.313c1.588-1.271,4.052-3.715,2.98-5.334"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M108.6,140.369a4.632,4.632,0,0,1,1.976-1.437,2.278,2.278,0,0,1,1.643.265"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M99.83,156.134a4.474,4.474,0,0,0,2.629,2.88c2.024.952,4.533.213,10.191-3.11,0,0,.367-.254.941-.67a49.287,49.287,0,0,0,4.932-4,7.8,7.8,0,0,0,1.217-1.434c1.3-2.192,1.255-3.55-.179-4.691a4.237,4.237,0,0,0-4.11-.986"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M113.911,147.459a3.274,3.274,0,0,0-.395,2.231,2.017,2.017,0,0,0,3.189,1.017c1.227-.983,3.135-2.873,2.3-4.128"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M114.7,146.463a3.579,3.579,0,0,1,1.533-1.111,1.744,1.744,0,0,1,1.268.207"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "e",
    points: "110.244 132.99 111.395 135.186 113.657 137.344 113.67 137.355"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M80.029,143.926a9.411,9.411,0,0,1-2.691-1.859,5.781,5.781,0,0,1-1.076-2.348,1.133,1.133,0,0,0-1.835-.656,2.489,2.489,0,0,0-.949,1.457,3.066,3.066,0,0,0,1.629,3.423"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "e",
    points: "109.402 73.203 74.547 80.383 73.901 77.242 63.415 26.35 102.091 18.38 105.233 17.734 114.966 64.958"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "e",
    points: "73.901 77.242 70.756 77.888 70.107 74.743 59.624 23.855 98.297 15.885 101.442 15.238 102.091 18.38 102.091 18.383"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "e",
    points: "70.107 74.743 66.962 75.393 55.829 21.356 97.651 12.74 98.297 15.885"
  }), /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 71.55,
    y1: 32.169,
    x2: 100.063,
    y2: 26.295
  }), /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 74.416,
    y1: 38.136,
    x2: 102.93,
    y2: 32.258
  }), /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 71.921,
    y1: 41.927,
    x2: 103.579,
    y2: 35.403
  }), /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 72.567,
    y1: 45.071,
    x2: 104.225,
    y2: 38.548
  }), /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 73.217,
    y1: 48.216,
    x2: 95.441,
    y2: 43.635
  }), /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 77.008,
    y1: 50.712,
    x2: 105.521,
    y2: 44.838
  }), /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 74.513,
    y1: 54.503,
    x2: 106.171,
    y2: 47.983
  }), /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 75.159,
    y1: 57.647,
    x2: 106.817,
    y2: 51.124
  }), /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 78.95,
    y1: 60.146,
    x2: 107.467,
    y2: 54.269
  }), /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 76.455,
    y1: 63.937,
    x2: 108.113,
    y2: 57.414
  }), /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 77.104,
    y1: 67.082,
    x2: 108.762,
    y2: 60.559
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "e",
    points: "87.212 73.193 90.44 72.53 94.275 71.739 102.242 70.096 103.755 69.783 106.295 69.261"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M96.6,68.343c-.1.365-.719,2.661.134,2.685.921.027,3.021-5.269,3.021-5.269s-1.028,4.3.216,4.389,1.063-3.059,2.142-3.351c.759-.207.13,2.041.13,3.3,0,.54.117.9.506.8.484-.12.776-.577,1.007-1.114.378-.9.594-2.021,1.268-2.189"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M92.6,69.89c.44,1.069,1.1,1.9,1.656,1.77,1.265-.306,2.207-2.928,2.341-3.317a.244.244,0,0,1,.01-.034v0l0-.01"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M92.6,69.89c1.02-1.925,1.584-4.183.364-3.87C91.78,66.326,91.969,68.35,92.6,69.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M90.416,72.416c.684-.185,1.529-1.285,2.186-2.526"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "e",
    points: "85.24 69.45 83.659 71.852 82.078 74.251"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "e",
    points: "81.256 70.271 83.659 71.852 86.058 73.43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M109.426,73.193a15.614,15.614,0,0,0,2.488,4.509,16.41,16.41,0,0,0,8.792,5.857l-.969,5.87a2.541,2.541,0,1,0,5.014.829l.98-5.943a16.74,16.74,0,0,0,4.341-.478A16.479,16.479,0,0,0,136.117,81a18.075,18.075,0,0,0,4.468-4.9A17.5,17.5,0,0,0,143,69.587a18.994,18.994,0,0,0-.883-9.788q-1.722-4.7-7.757-8.256l-2.925-1.77,2.048-12.411a6.533,6.533,0,0,1,1.024.959,5.2,5.2,0,0,1,1.2,3.2,1.944,1.944,0,0,0,1.633,1.8l7.118,1.175a1.957,1.957,0,0,0,2.279-1.814,17.7,17.7,0,0,0-.385-4.671,16.957,16.957,0,0,0-2.509-5.932,15.05,15.05,0,0,0-4.568-4.358,16.327,16.327,0,0,0-3.911-1.76l.859-5.214a2.541,2.541,0,1,0-5.015-.828l-.862,5.227a17.515,17.515,0,0,0-4.125.361,15.484,15.484,0,0,0-5.887,2.574,16.637,16.637,0,0,0-4.62,4.757,16.874,16.874,0,0,0-2.467,6.506,15.691,15.691,0,0,0,1.495,10.3,19.126,19.126,0,0,0,7.54,7.461l2.551,1.447-2.31,14a4.219,4.219,0,0,1-2.141-2.162,11.043,11.043,0,0,1-.756-2.544,3.082,3.082,0,0,0-2.527-2.529l-2.134-.351v0l-3.007-.5a3.08,3.08,0,0,0-3.575,3.11,16.968,16.968,0,0,0,.571,4.121C109.092,72.21,109.25,72.708,109.426,73.193Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M124.4,44.267a6.743,6.743,0,0,1-.278-3.241,6.137,6.137,0,0,1,2.134-3.774,4.692,4.692,0,0,1,2.265-1.069l-1.77,10.72A5.8,5.8,0,0,1,124.4,44.267Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M129.367,72.275a7.486,7.486,0,0,1-1.773.756l1.917-11.61a7.321,7.321,0,0,1,2.018,2.324,6.783,6.783,0,0,1,.574,4.275A5.691,5.691,0,0,1,129.367,72.275Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStreamlineIconBusinessDeal250X250);
export default __webpack_public_path__ + "static/media/streamline-icon-business-deal@250x250.732f97e91ca444c9e980115977a1a6f3.svg";
export { ForwardRef as ReactComponent };